'use client'
import { getScreenOrientation } from '@/ug-core/utils/deviceUtils'
import { avatars } from '../playground-avatar/config/avatars'
import Demo from './Demo'
import { useEffect, useState, useRef, useCallback } from 'react'
import { StringMessage } from '@/ug-core/types'

// Scattergories letters, excluding H, J, K, Q, U, V, W, X, Y, Z
const SCATTERGORIES_LETTERS = 'ABCDEFGILMNOPRST'.split('')

// Fisher-Yates shuffle algorithm
const shuffle = (array: string[]) => {
  let currentIndex = array.length,
    randomIndex

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--
    ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
  }

  return array
}

export default function ScattergoriesPage() {
  // on prd and dev it's the same component id
  const COMPONENT = 'comp-ug.scattergories.scattergories-nyo8'
  const PERSONA = '2d090ceeadc1da9057f88af88d10741a'
  const AVATAR = avatars.hawaii_robot
  const IMAGE_FRAME = 'fullscreen'

  const shuffledLettersRef = useRef<string[]>([])
  const currentLetterIndexRef = useRef<number>(0)
  const [currentLetter, setCurrentLetter] = useState<string>("a")

  useEffect(() => {
    const initialLetters = shuffle([...SCATTERGORIES_LETTERS])
    shuffledLettersRef.current = initialLetters
    currentLetterIndexRef.current = 0
    const firstLetter = initialLetters[0]
    setCurrentLetter(firstLetter)
    console.debug(`Picked letter ${firstLetter}`)
  }, [])

  const handleStringMessage = useCallback((message: StringMessage) => {
    if (message.source_name === 'round_ended' && message.string === 'yes') {
      let letters = shuffledLettersRef.current
      let nextIndex = currentLetterIndexRef.current + 1

      if (nextIndex >= letters.length) {
        // Reshuffle and start from the beginning
        letters = shuffle([...SCATTERGORIES_LETTERS])
        shuffledLettersRef.current = letters
        nextIndex = 0
      }

      currentLetterIndexRef.current = nextIndex
      const newLetter = letters[nextIndex]
      setCurrentLetter(newLetter)
      console.debug(`Picked letter ${newLetter}`)
    }
  }, [])

  return (
    <Demo
      componentId={COMPONENT}
      personaId={PERSONA}
      avatarAsset={AVATAR}
      imageFrame={IMAGE_FRAME}
      onStringMessage={handleStringMessage}
      contextValues={{
        is_horizontal: getScreenOrientation() === 'horizontal',
        letter: currentLetter,
      }}
    />
  )
}
